import RemainingPayment from "./remaining-payment";
import {
  OrderType,
  PaymentStatus,
  usePaymentContext,
} from "../providers/PaymentProvider";
import OrderLoader from "widgets/shared/order-loader";
import Card from "shared/ui/card";
import FullyPaid from "./fully-paid";
import AllPayments from "./all-payments";
import CustomPayment from "./custom-payment";
import ContactCustomerService from "widgets/shared/contact-customer-service";
import PaymentSidebarProducts from "../../../widgets/payment-sidebar-products";
import PaymentSidebarStandardProducts from "../../../widgets/payment-sidebar-standard-products";
import PaymentFooter from "widgets/payment/payment-footer";
import { ZakelijkPaymentPage } from "../zakelijk/ZakelijkPaymentPage";

export default function Partials() {
  const {
    loaded,
    isPaid,
    getPaymentTypeList,
    paymentStatus,
    paymentAction,
    setPaymentAction,
    setBank,
    setPaymentMethod,
    doorOrder,
    standardProductOrder,
    orderType,
    doorOrderError,
  } = usePaymentContext();

  // For zakelijk order, use custom payment component
  if (doorOrder?.isZakelijkOrder) {
    return <ZakelijkPaymentPage />;
  }

  const getComponentForPaymentStatus = () => {
    switch (paymentStatus) {
      case PaymentStatus.FULLY_PAID:
        return <FullyPaid />;
      case PaymentStatus.CUSTOM_PAYMENT:
        return <CustomPayment />;
      case PaymentStatus.PARTIAL_PAYMENT:
        return <RemainingPayment paymentTypeList={getPaymentTypeList([])} />;
      default:
        return (
          <AllPayments
            paymentAction={paymentAction}
            setPaymentAction={setPaymentAction}
            setBank={setBank}
            setPaymentMethod={setPaymentMethod}
            paymentTypeList={getPaymentTypeList([])}
          />
        );
    }
  };

  const getSidebarComponent = () => {
    switch (orderType) {
      case OrderType.STANDARD_PRODUCT:
        return (
          <PaymentSidebarStandardProducts
            products={standardProductOrder?.products || []}
          />
        );
      case OrderType.DOOR:
      default:
        return <PaymentSidebarProducts />;
    }
  };

  return (
    <>
      <Card className="gg-px-4 gg-py-14 sm:gg-px-14 2xl:gg-px-24">
        {doorOrderError ? (
          <ContactCustomerService />
        ) : !loaded ? (
          <OrderLoader />
        ) : (
          <div className="gg-grid gg-grid-cols-12">
            {getComponentForPaymentStatus()}
            <div className="gg-col-span-12 xl:gg-col-span-6">
              {getSidebarComponent()}
            </div>
          </div>
        )}
      </Card>

      {!isPaid() && loaded && (
        <PaymentFooter
          hideVoucher={
            !loaded || orderType === OrderType.DOOR
              ? doorOrder?.shoppingCart?.sampleSale
              : false
          }
        />
      )}
    </>
  );
}
